import { NavLink } from 'react-router-dom';
import styled from 'styled-components/macro';

import { mqMedium } from 'styles/breakpoints';
import { defaultFocusStyles, transition } from 'theme/themeConstants';

export const LogoWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const SourceLabel = styled.span`
  position: absolute;
  bottom: -2rem;
  left: 0;
  font-size: 1rem;
  font-weight: 700;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const LogoLink = styled(NavLink)`
  display: block;

  :focus {
    ${defaultFocusStyles}
  }
`;

export const LogoImage = styled.img`
  max-height: 3rem;
  transition: max-height ${transition.default};
  will-change: max-height;

  ${mqMedium`
    max-height: ${({ biggerHeader }) => (biggerHeader ? '4rem' : '3rem')};
  `}
`;
